import Snackbar, {
  SnackbarIntent as ISnackbarIntent,
  SnackbarProps as ISnackbarProps,
} from './Snackbar'

export type SnackbarIntent = ISnackbarIntent
export type SnackbarProps = ISnackbarProps

export default Snackbar
